<template>
  <div class="lol-container">
    <h1>Counter-SKbrunk Turneringen</h1>
    <div class="warning-banner">
      <strong>VIKTIG INFORMATION:</strong> Var redo i god tid. Alla lag blir inbjudna till en Discord där ni får mer information inför matchstart.
    </div>
    <div class="subtitle">
      Matcher spelas med 45 minuters mellanrum från kl 16:00.<br>
      Sista matchen för dagen beräknas starta kl 21:15.
    </div>
    <div class="subtitle">
      Klicka här för vår discord server och twitch!<br><br>
      <div class="button-container">
        <a href="https://discord.gg/T5nqF7nGa" target="_blank" class="discord-btn">
          <img src="https://logos-world.net/wp-content/uploads/2020/12/Discord-Logo.png" height="110px" width="200px" alt="Discord" class="icon" />
        </a>
        <a href="https://twitch.tv/pirayagamingproviders" target="_blank" class="twitch-btn">
          <img src="https://upload.wikimedia.org/wikipedia/commons/a/a7/Twitch_BlackLogo.svg" height="80px" width="200px" alt="Twitch"  class="icon" />
        </a>
      </div>
    </div>

    <!-- Tournament Bracket -->
    <div class="bracket-section">
      <h2 class="bracket-title">Turnerings Bracket</h2>
      <div class="ncaa-layout">
        <div class="tree tree-left">
          <div class="tree-title">Vänster Träd</div>

          <div class="bracket-round r1">
            <div class="round-label">Runda 1</div>
            <div class="match" v-for="(match, i) in bracket.left.round1" :key="'l-r1-' + i">
              <div class="match-time">{{ match.time }}</div>
              <div class="team blue-team" :class="{ winner: match.winner === match.team1 }"><span class="team-name">{{ match.team1 }}</span><span v-if="match.score1 !== undefined" class="team-score">{{ match.score1 }}</span></div>
              <div class="team red-team" :class="{ winner: match.winner === match.team2 }"><span class="team-name">{{ match.team2 }}</span><span v-if="match.score2 !== undefined" class="team-score">{{ match.score2 }}</span></div>
            </div>
          </div>

          <div class="bracket-round r2">
            <div class="round-label">Kvartsfinal</div>
            <div class="match" v-for="(match, i) in bracket.left.round2" :key="'l-r2-' + i">
              <div class="match-time">{{ match.time }}</div>
              <div class="team blue-team" :class="{ winner: match.winner === match.team1 }"><span class="team-name">{{ match.team1 }}</span><span v-if="match.score1 !== undefined" class="team-score">{{ match.score1 }}</span></div>
              <div class="team red-team" :class="{ winner: match.winner === match.team2 }"><span class="team-name">{{ match.team2 }}</span><span v-if="match.score2 !== undefined" class="team-score">{{ match.score2 }}</span></div>
            </div>
          </div>

          <div class="bracket-round r3">
            <div class="round-label">Semifinal</div>
            <div class="match" v-for="(match, i) in bracket.left.round3" :key="'l-r3-' + i">
              <div class="match-time">{{ match.time }}</div>
              <div class="team blue-team" :class="{ winner: match.winner === match.team1 }"><span class="team-name">{{ match.team1 }}</span><span v-if="match.score1 !== undefined" class="team-score">{{ match.score1 }}</span></div>
              <div class="team red-team" :class="{ winner: match.winner === match.team2 }"><span class="team-name">{{ match.team2 }}</span><span v-if="match.score2 !== undefined" class="team-score">{{ match.score2 }}</span></div>
            </div>
          </div>
        </div>

        <div class="center-final">
          <div class="round-label">Grand Final (Bo3)</div>
          <div class="match final-match">
            <div class="match-time">{{ bracket.grandFinal.time }}</div>
            <div class="team blue-team" :class="{ winner: bracket.grandFinal.winner === bracket.grandFinal.team1 }"><span class="team-name">{{ bracket.grandFinal.team1 }}</span><span v-if="bracket.grandFinal.score1 !== undefined" class="team-score">{{ bracket.grandFinal.score1 }}</span></div>
            <div class="team red-team" :class="{ winner: bracket.grandFinal.winner === bracket.grandFinal.team2 }"><span class="team-name">{{ bracket.grandFinal.team2 }}</span><span v-if="bracket.grandFinal.score2 !== undefined" class="team-score">{{ bracket.grandFinal.score2 }}</span></div>
          </div>

          <div class="round-label champion-label">Mästare</div>
          <div class="champion-box">
            <div class="champion-name">{{ bracket.champion }}</div>
          </div>
        </div>

        <div class="tree tree-right">
          <div class="tree-title">Höger Träd</div>

          <div class="bracket-round r3">
            <div class="round-label">Semifinal</div>
            <div class="match" v-for="(match, i) in bracket.right.round3" :key="'r-r3-' + i">
              <div class="match-time">{{ match.time }}</div>
              <div class="team blue-team" :class="{ winner: match.winner === match.team1 }"><span class="team-name">{{ match.team1 }}</span><span v-if="match.score1 !== undefined" class="team-score">{{ match.score1 }}</span></div>
              <div class="team red-team" :class="{ winner: match.winner === match.team2 }"><span class="team-name">{{ match.team2 }}</span><span v-if="match.score2 !== undefined" class="team-score">{{ match.score2 }}</span></div>
            </div>
          </div>

          <div class="bracket-round r2">
            <div class="round-label">Kvartsfinal</div>
            <div class="match" v-for="(match, i) in bracket.right.round2" :key="'r-r2-' + i">
              <div class="match-time">{{ match.time }}</div>
              <div class="team blue-team" :class="{ winner: match.winner === match.team1 }"><span class="team-name">{{ match.team1 }}</span><span v-if="match.score1 !== undefined" class="team-score">{{ match.score1 }}</span></div>
              <div class="team red-team" :class="{ winner: match.winner === match.team2 }"><span class="team-name">{{ match.team2 }}</span><span v-if="match.score2 !== undefined" class="team-score">{{ match.score2 }}</span></div>
            </div>
          </div>

          <div class="bracket-round r1">
            <div class="round-label">Runda 1</div>
            <div class="match" v-for="(match, i) in bracket.right.round1" :key="'r-r1-' + i">
              <div class="match-time">{{ match.time }}</div>
              <div class="team blue-team" :class="{ winner: match.winner === match.team1 }"><span class="team-name">{{ match.team1 }}</span><span v-if="match.score1 !== undefined" class="team-score">{{ match.score1 }}</span></div>
              <div class="team red-team" :class="{ winner: match.winner === match.team2 }"><span class="team-name">{{ match.team2 }}</span><span v-if="match.score2 !== undefined" class="team-score">{{ match.score2 }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h2 class="bracket-title">FAQ</h2>
    <div class="info-boxes">
      <div class="info-box" v-for="(section, index) in sections" :key="index">
        <h2>{{ section.title }}</h2>
        <div class="box-content" v-html="section.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CsPage',
  data() {
    return {
      bracket: {
        left: {
          round1: [
            { team1: 'NUKELOVERS', team2: 'LARKERS SEGJÄRN', winner: 'LARKERS SEGJÄRN', score1: 6, score2: 13, time: 'Ons 8/4 16:00' },
            { team1: 'CAMPEONES', team2: 'SANDELS', winner: 'CAMPEONES', score1: 13, score2: 9, time: 'Ons 8/4 16:45' },
            { team1: 'SVP BOTS', team2: 'MASSIVELY OVERATED', winner: 'SVP BOTS', score1: 13, score2: 6, time: 'Ons 8/4 17:30' },
            { team1: 'SKEÅL', team2: 'CUTTING EDGE', winner: 'SKEÅL', score1: 13, score2: 4, time: 'Ons 8/4 18:15' }
          ],
          round2: [
            { team1: 'LARKERS SEGJÄRN', team2: 'CAMPEONES', winner: 'LARKERS SEGJÄRN', score1: 13, score2: 7, time: 'Tors 9/4 18:00' },
            { team1: 'SVP BOTS', team2: 'SKEÅL', winner: 'SVP BOTS', score1: 13, score2: 5, time: 'Tors 9/4 18:45' }
          ],
          round3: [
            { team1: 'LARKERS SEGJÄRN', team2: 'SVP BOTS', winner: 'SVP BOTS', score1: 2, score2: 13, time: 'Tors 9/4 21:45' }
          ]
        },
        right: {
          round1: [
            { team1: 'H.O.M.E.R', team2: 'SVEDJEHED FANCLUB', winner: 'H.O.M.E.R', score1: 13, score2: 6, time: 'Ons 8/4 19:00' },
            { team1: 'CT ACADEMY', team2: 'MILK', winner: 'MILK', score1: 0, score2: 13, time: 'Ons 8/4 19:45' },
            { team1: 'MUMINTROLLEN', team2: '954', winner: '954', score1: 6, score2: 13, time: 'Tors 9/4 16:30' },
            { team1: 'DMP FT MASKIN', team2: 'DRAKENS VÄRLD', winner: 'DMP FT MASKIN', score1: 13, score2: 2, time: 'Tors 9/4 17:15' }
          ],
          round2: [
            { team1: 'H.O.M.E.R', team2: 'MILK', winner: 'MILK', score1: 10, score2: 13, time: 'Tors 9/4 19:30' },
            { team1: '954', team2: 'DMP FT MASKIN', winner: '954', score1: 13, score2: 6, time: 'Tors 9/4 20:15' }
          ],
          round3: [
            { team1: 'MILK', team2: '954', winner: 'MILK', score1: 2, score2: 13, time: 'Tors 9/4 21:00' }
          ]
        },
        grandFinal: {
          team1: 'SVP BOTS',
          team2: 'MILK',
          winner: null,
          time: 'Lör 11/4 18:30 (Bo3)'
        },
        champion: 'TBD'
      },
      sections: [
        {
          title: 'Format & Utslagning',
          content: `
            <p>Turneringen spelas som Single Elimination (Bäst av 1). Förlorar man är man ute.</p>
            <p>Vinnarna går vidare till nya matcher på torsdag. Kvarts- och semifinaler leder till den stora finalen på lördag.</p>
          `
        },
        {
          title: 'Grand Final',
          content: `
            <p>Finalen spelas på Lördag kl 18:30.</p>
            <p>Det är Bäst av 3 (Bo3) som gäller, och även om den livesänds på Origo så spelar alla hemifrån.</p>
          `
        },
        {
          title: 'Tider & Matchstart',
          content: `
            <p>Matcher spelas med 45 minuters mellanrum. Start kl 16:00.</p>
            <p>Sista matchen för dagen beräknas starta kl 21:15.</p>
            <p><strong>Viktigt:</strong> Var redo i god tid. Ni kommer att bli inbjudna till en Discord där ni får mer information.</p>
          `
        },
        {
          title: 'Kartval (Map Veto)',
          content: `
            <p>Innan matchen väljs kartan via Premier Veto-systemet, precis som i spelets vanliga Premier-läge.</p>
          `
        },
        {
          title: 'Server & Hosting',
          content: `
            <p>Vi hostar spelet på egna servrar och jobbar stenhårt för att det ska lira så bra som möjligt.</p>
            <p>Skulle det bli strul så tänk på att det är lika för alla. Vi löser eventuella problem så fort vi bara kan.</p>
          `
        },
        {
          title: 'Livestream & Community',
          content: `
            <p>Då vi live-streamar alla matcher med kommentatorer hinner vi tyvärr inte köra annat än turneringsspel (inga tröstmatcher).</p>
            <p>Vi gör detta som en kul grej, så kom in på streamen och häng i chatten oavsett hur det går för ert lag.</p>
          `
        },
        {
          title: 'Fler funderingar?',
          content: `
            <p>Skicka ett DM till oss på Instagram!</p>
          `
        }
      ]
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=IM+Fell+English+SC&display=swap');

.subtitle {
  width: 100%;
  max-width: 99%;
  padding-top: 2%;
  padding-bottom: 2%;
  border-radius: 18px;
  margin-bottom: 32px;
  color: #e0e0e0;
  font-size: 1.8rem;
  text-align: center;
  font-family: 'IM Fell English SC', serif;
  background-color: #a8180c;
  background: rgba(20, 20, 20, 0.92);
  text-shadow: 0 2px 16px #000000, 1 1px 0 #000;
}

.warning-banner {
  background: #e3eb05;
  color: #000000;
  padding: 12px 20px;
  border-radius: 8px;
  font-family: 'IM Fell English SC', serif;
  margin-bottom: 24px;
  text-align: center;
  box-shadow: 0 2px 16px rgba(0,0,0,0.45);
}

.lol-container {
  min-height: 100vh;
  background: #000;
  padding: 48px 8vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.button-container {
  gap: 100px;
}

.button-container a:hover .icon {
  transform: scale(1.05);
  transition: transform 0.2s;

}
  

h1 {
  font-family: 'IM Fell English SC', serif;
  color: #fff;
  font-size: clamp(2.2rem, 6vw, 4.5rem);
  text-align: center;
  text-shadow: 0 2px 16px #a8180c, 0 1px 0 #000;
  margin-top: 0;
  margin-bottom: 48px;
  letter-spacing: 0.04em;
}

.info-boxes {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  width: 100%;
  max-width: 1400px;
}

.info-box {
  background: rgba(20, 20, 20, 0.92);
  padding: 28px 24px;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.45);
  color: #fff;
  font-family: 'IM Fell English SC', serif;
  transition: transform 0.2s;
}

.info-box:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 8px 32px #a8180c55;
}

.info-box h2 {
  font-family: 'IM Fell English SC', serif;
  font-size: 1.5rem;
  color: #fff;
  margin-top: 0;
  margin-bottom: 16px;
  text-shadow: 0 2px 8px #a8180c;
  border-bottom: 2px solid #a8180c;
  padding-bottom: 8px;
}

.box-content {
  font-size: 1.05rem;
  line-height: 1.6;
}

.box-content h3 {
  font-family: 'IM Fell English SC', serif;
  font-size: 1.2rem;
  color: #e8e8e8;
  margin: 16px 0 8px 0;
  text-shadow: 0 1px 4px #a8180c88;
}

.box-content p {
  margin: 8px 0;
  color: #e0e0e0;
}

.box-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.box-content li {
  padding: 6px 0;
  padding-left: 20px;
  position: relative;
  color: #e0e0e0;
}

.box-content li::before {
  content: '•';
  color: #a8180c;
  font-size: 1.2rem;
  position: absolute;
  left: 0;
}

.box-content a {
  color: #ffd700;
  text-decoration: none;
  transition: color 0.2s;
}

.box-content a:hover {
  color: #ffec8b;
  text-decoration: underline;
}

.box-content .twitch-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #9146ff;
  color: #fff;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: bold;
  text-decoration: none;
  transition: background 0.2s, transform 0.2s;
  margin: 12px 0;
}

.box-content .twitch-btn:hover {
  background: #772ce8;
  transform: scale(1.05);
  color: #fff;
  text-decoration: none;
}

.box-content .twitch-btn svg {
  flex-shrink: 0;
}

.box-content strong {
  color: #fff;
}

@media (max-width: 1100px) {
  .info-boxes {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .lol-container {
    padding: 24px 4vw;
  }

  .info-boxes {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  h1 {
    font-size: clamp(1.2rem, 8vw, 2rem);
    margin-bottom: 24px;
  }

  .info-box {
    padding: 20px 16px;
  }

  .info-box h2 {
    font-size: 1.2rem;
  }

  .box-content {
    font-size: 0.95rem;
  }
}

/* NCAA / NBA bracket layout */
.bracket-section {
  width: 100%;
  max-width: 1320px;
  margin-top: 64px;
  margin-bottom: 64px;
  padding: 22px;
  background: rgba(20, 20, 20, 0.92);
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.45);
}

.bracket-title {
  font-family: 'IM Fell English SC', serif;
  font-size: 2rem;
  color: #fff;
  text-align: center;
  text-shadow: 0 2px 16px #a8180c, 0 1px 0 #000;
  margin-top: 0;
  margin-bottom: 32px;
  letter-spacing: 0.04em;
}

.ncaa-layout {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  overflow-x: hidden;
  padding: 10px 0;

  --match-height: 86px;
  --match-gap: 10px;
  --tree-line: rgba(255, 215, 0, 0.35);
  --line-len: 12px;
}

.tree {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.tree-left {
  justify-content: flex-end;
}

.tree-right {
  justify-content: flex-start;
}

.tree-title {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.bracket-round {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 146px;
}

.round-label {
  font-family: 'IM Fell English SC', serif;
  font-size: 0.92rem;
  color: #a8180c;
  text-align: center;
  margin-bottom: 4px;
  text-shadow: 0 1px 4px #000;
  font-weight: bold;
}

.match {
  background: rgba(40, 40, 40, 0.9);
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #333;
  transition: transform 0.2s, box-shadow 0.2s;
  min-height: var(--match-height);
  position: relative;
}

.match-time {
  font-family: 'IM Fell English SC', serif;
  font-size: 0.72rem;
  color: #ffd700;
  text-align: center;
  padding: 3px 6px;
  background: rgba(0, 0, 0, 0.5);
  border-bottom: 1px solid #444;
  font-weight: bold;
}

.match:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 16px #a8180c44;
}

.team {
  font-family: 'IM Fell English SC', serif;
  font-size: 0.73rem;
  color: #ccc;
  padding: 5px 7px;
  border-bottom: 1px solid #444;
  transition: background 0.2s, color 0.2s;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
}

.team-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.team-score {
  flex-shrink: 0;
  font-weight: bold;
  font-size: 1.4rem;
}

.team:last-child {
  border-bottom: none;
}

/* Blue team (left/home) */
.team.blue-team {
  border-left: 4px solid #1e90ff;
  background: linear-gradient(90deg, rgba(30, 144, 255, 0.15) 0%, transparent 100%);
}

/* Red team (right/away) */
.team.red-team {
  border-left: 4px solid #dc3545;
  background: linear-gradient(90deg, rgba(220, 53, 69, 0.15) 0%, transparent 100%);
}

.team.winner {
  font-weight: bold;
  color: #ffd700;
  text-shadow: 0 0 10px #ffd700, 0 0 20px #ffd700, 0 0 30px #ffb700;
  animation: winner-glow 2s ease-in-out infinite alternate;
}

@keyframes winner-glow {
  from {
    text-shadow: 0 0 10px #ffd700, 0 0 20px #ffd700, 0 0 30px #ffb700;
  }
  to {
    text-shadow: 0 0 15px #ffd700, 0 0 30px #ffd700, 0 0 45px #ffb700;
  }
}

.team.blue-team.winner {
  border-left-color: #1e90ff;
}

.team.red-team.winner {
  border-left-color: #dc3545;
}

/* Symmetric spacing across both trees */
.r1 .match {
  margin-bottom: var(--match-gap);
}

.r1 .match:last-child {
  margin-bottom: 0;
}

.r2 {
  margin-top: calc((var(--match-height) + var(--match-gap)) / 2);
}

.r2 .match {
  margin-bottom: calc(var(--match-height) + (2 * var(--match-gap)));
}

.r2 .match:last-child {
  margin-bottom: 0;
}

.r3 {
  margin-top: calc((3 * (var(--match-height) + var(--match-gap))) / 2);
}

.center-final {
  margin-top: calc((7 * (var(--match-height) + var(--match-gap))) / 2);
  min-width: 190px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.final-match {
  border: 2px solid #a8180c;
  box-shadow: 0 0 20px #a8180c44;
  width: 100%;
}

.final-match .team {
  font-size: 0.8rem;
  padding: 6px 8px;
}

/* Bracket connector lines */
.tree-left .match::after {
  content: '';
  position: absolute;
  top: 50%;
  right: calc(-1 * var(--line-len));
  width: var(--line-len);
  border-top: 1px solid var(--tree-line);
}

.tree-right .match::before {
  content: '';
  position: absolute;
  top: 50%;
  left: calc(-1 * var(--line-len));
  width: var(--line-len);
  border-top: 1px solid var(--tree-line);
}

.center-final .final-match::before,
.center-final .final-match::after {
  content: '';
  position: absolute;
  top: 50%;
  width: var(--line-len);
  border-top: 1px solid var(--tree-line);
}

.center-final .final-match::before {
  left: calc(-1 * var(--line-len));
}

.center-final .final-match::after {
  right: calc(-1 * var(--line-len));
}

.champion-label {
  margin-top: 10px;
}

.champion-box {
  background: linear-gradient(135deg, #ffd700 0%, #ffb700 50%, #ffd700 100%);
  border-radius: 12px;
  padding: 20px 24px;
  text-align: center;
  box-shadow: 0 4px 24px rgba(255, 215, 0, 0.4);
  border: 2px solid #fff;
}

.champion-name {
  font-family: 'IM Fell English SC', serif;
  font-size: 1.2rem;
  color: #000;
  font-weight: bold;
  text-shadow: 0 1px 2px rgba(255,255,255,0.5);
}

@media (max-width: 1250px) {
  .ncaa-layout {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 700px) {
  .bracket-section {
    padding: 16px;
    margin-top: 32px;
  }

  .bracket-title {
    font-size: 1.4rem;
    margin-bottom: 24px;
  }

  .ncaa-layout {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
